import cn from 'classnames'
import React, { FC, memo } from 'react'

import { WixStudioSidePanelText } from '../../../reusable/WixStudioSidePanelText'
import { WixStudioTemplateSidePanel } from '../../../reusable/WixStudioTemplate/WixStudioTemplateSidePanel'
import { WixStudioWelcomeAnimation } from '../../../reusable/WixStudioWelcomeAnimation'
import { wixStudioWelcomeDataHooks as dataHooks } from '../WixStudioWelcome.dataHooks'
import s from './SidePanel.scss'

export const SidePanel: FC<{ image?: string; texts: { text: string; isActive: boolean }[] }> = memo(
  ({ image = 'none', texts }) => (
    <WixStudioTemplateSidePanel className={cn(s.root, s[image])} dataHook={dataHooks.sidePanel()}>
      <div className={s.animationContainer}>
        <WixStudioWelcomeAnimation image={image} />
      </div>
      <div className={cn(s.textContainer, s[image])}>
        {texts.map(({ text, isActive }, index) => (
          <div key={index} className={cn(s.text, isActive && s.active)}>
            <WixStudioSidePanelText text={text} />
          </div>
        ))}
      </div>
    </WixStudioTemplateSidePanel>
  ),
)
